import React from 'react';

interface LoadingSkeletonProps {
  className?: string;
  height?: string;
  width?: string;
  rounded?: boolean;
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ 
  className = '', 
  height = 'h-4', 
  width = 'w-full',
  rounded = true 
}) => {
  return (
    <div 
      className={`animate-pulse bg-gray-700 ${height} ${width} ${rounded ? 'rounded' : ''} ${className}`}
    />
  );
};

interface DashboardSkeletonProps {
  showReportCards?: boolean;
  showMattersList?: boolean;
  showMedicalUpload?: boolean;
}

export const DashboardSkeleton: React.FC<DashboardSkeletonProps> = ({
  showReportCards = true,
  showMattersList = true,
  showMedicalUpload = true
}) => {
  return (
    <div className="space-y-8">
      {/* Stats Cards Skeleton */}
      {showReportCards && (
        <div className="space-y-6">
          <LoadingSkeleton height="h-4" width="w-1/4" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <LoadingSkeleton height="h-32" rounded />
            <LoadingSkeleton height="h-32" rounded />
          </div>
          
          {/* Revenue and Productivity Row */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <LoadingSkeleton height="h-48" rounded />
            <div className="lg:col-span-2">
              <LoadingSkeleton height="h-48" rounded />
            </div>
          </div>
        </div>
      )}

      {/* Matters List Skeleton */}
      {showMattersList && (
        <div className="space-y-4">
          <LoadingSkeleton height="h-4" width="w-1/3" />
          <div className="space-y-3">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex items-center space-x-4 p-4 bg-gray-800 rounded-lg border border-gray-700">
                <LoadingSkeleton height="h-10" width="w-10" />
                <div className="flex-1 space-y-2">
                  <LoadingSkeleton height="h-4" width="w-3/4" />
                  <LoadingSkeleton height="h-3" width="w-1/2" />
                </div>
                <LoadingSkeleton height="h-8" width="w-20" />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Medical Upload Skeleton */}
      {showMedicalUpload && (
        <div className="space-y-4">
          <LoadingSkeleton height="h-4" width="w-1/4" />
          <LoadingSkeleton height="h-40" rounded />
        </div>
      )}
    </div>
  );
};

export default LoadingSkeleton;
